module.exports = __webpack_public_path__ + "img/title.f20255c7.png";